<template>
  <div class="ds-radio-button">
    <input
      type="radio"
      :id="id"
      :name="name"
      :value="value"
      @change="selectedItem"
      ds-component="DsRadioButton"
      :disabled="disabled"
    />
    <label :for="id">{{ label }} </label>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Tokens from '@ds/tokens';

export default Vue.extend({
  name: 'DsRadioButton',
  props: {
    id: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    value: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    isChecked: {
      type: Boolean
    },
    dark: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    selectedItem() {
      this.$emit('checked', !this.isChecked);
    }
  },
  mounted() {
    document.documentElement.setAttribute('data-color-theme', this.dark ? 'dark' : '');
  }
});
</script>

<style lang="scss" scoped>
@import '~@ds/styles/RadioButton.scss';
</style>
